<template>
    <a v-if="hasHistory" class="back__button" @click.prevent="routerBack()">
        <i class=" pi pi-angle-left"></i>
        Back
    </a>
</template>

<script>
export default {
    methods: {
        routerBack() {
            console.log(
            'clicked'
            )
            window.history.back();
        }
    },
    computed: {
        hasHistory() {
            if (window.history.length > 1) {
                return window.history.length;
            } else {
                return false;
            }
        }
    }
}
</script>